import { FlaskConical, Leaf, ShieldCheck } from "lucide-react";

const stats = [
  {
    icon: FlaskConical,
    value: "4×",
    label: "Clinically studied ingredients"
  },
  {
    icon: Leaf,
    value: "0g",
    label: "Sugar — no crash, no jitters"
  },
  {
    icon: ShieldCheck,
    value: "30 Day",
    label: "Money-back guarantee"
  }
];

const StatsBar = () => {
  return (
    <section 
      className="relative py-8 border-y border-white/10"
      data-testid="stats-bar"
    >
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {stats.map((stat, index) => (
            <div 
              key={index}
              className="flex items-center justify-center md:justify-start gap-4 text-center md:text-left"
              data-testid={`stat-${index}`}
            >
              <div className="w-12 h-12 rounded-xl bg-nukleus-violet/10 flex items-center justify-center shrink-0">
                <stat.icon className="w-5 h-5 text-nukleus-violet" />
              </div>
              <div>
                <span className="text-2xl font-bold text-white">{stat.value}</span>
                <p className="text-sm text-white/50">{stat.label}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StatsBar;
